import { footerPartners } from '@/mocks/niuniuData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-white">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 w-full py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-1">
            <h3 className="font-heading text-2xl text-primary-400 mb-3">牛牛影视</h3>
            <p className="text-sm text-white/60 leading-relaxed">
              牛牛影视全站免费，覆盖电影大全、电视剧全集与综艺，免费追剧在线观看无需付费，高清流畅不缓冲，打造免费影视聚合入口。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#carousel" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">焦点专题</a>
              <a href="#ranking" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">热门榜单</a>
              <a href="#updates" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">最新快讯</a>
              <a href="#cards" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">主题推荐</a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">内容分类</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">电影大全</a>
              <a href="#index" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">电视剧全集</a>
              <a href="#index" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">热门综艺</a>
              <a href="#index" className="block text-sm text-white/50 hover:text-primary-400 transition-colors">高分动漫</a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium text-white mb-3">联系我们</h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-white/50">
                <i className="ri-mail-line"></i>
                <span>feedback@niuniuys.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-white/50">
                <i className="ri-wechat-line"></i>
                <span>niuniu_movie</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 mb-8">
          <h4 className="text-xs font-medium text-white/40 mb-4 text-center tracking-wider">合作伙伴</h4>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3">
            {footerPartners.map((p, i) => (
              <span key={i} className="text-xs text-white/30">{p}</span>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2020-2026 牛牛影视 niuniuys.com 版权所有
          </p>
          <p className="text-xs text-white/30">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}